/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'question': {
    width: 8,
    height: 12,
    viewBox: '0 0 8 12',
    data: '<path pid="0" d="M5 8.82H3V5.88h1a1.96 1.96 0 10-2-1.96H0a4 4 0 115 3.8v1.1zm.25 1.96A1.25 1.25 0 114 9.56a1.24 1.24 0 011.25 1.22z" _fill="#fff" fill-rule="evenodd"/>'
  }
})
